import { createRoute } from "@tanstack/solid-router";
import { lazy, Suspense } from "solid-js";
import { appRoute } from "./route";

const DevicesView = lazy(async () => {
  const m = await import("@/features/workforce/components/devices-view");
  return { default: m.DevicesView };
});

export const devicesRoute = createRoute({
  getParentRoute: () => appRoute,
  path: "/devices",
  component: () => (
    <Suspense fallback={null}>
      <DevicesView />
    </Suspense>
  ),
});
